import { collection, getDocs } from "firebase/firestore";
import { db } from "../FirebaseConfig";

export const listNameExists = async (user, listName) => {
  const shoppingListRef = collection(db, "users", user.uid, "shoppingList");
  const snapshot = await getDocs(shoppingListRef);
  const isExist = snapshot.docs.some((doc) => doc.data().listName === listName);
  return isExist;
};
